import { useAtom, useSetAtom } from "jotai";
import { useRouter } from "next/router";

import { Line } from "@sorcery/ui";

import { useUser } from "~/providers/UserProvider";
import { fullCollectionlistJotai } from "~/state/collectionJotai";
import { trackingJotai } from "~/state/deckJotai";
import { collectionPath } from "~/utils/paths";
import { api, jotaiStateDelegationOptions } from "~/utils/trpc";

export const DeckCollectionToolbar = () => {
  const [tracking, setTracking] = useAtom(trackingJotai);
  const { user } = useUser();
  const { push } = useRouter();

  const setFullCollectionlist = useSetAtom(fullCollectionlistJotai);
  api.collection.getCollectionlistBySession.useQuery(undefined, {
    ...jotaiStateDelegationOptions,
    enabled: tracking,
    select: (data) => {
      data && setFullCollectionlist(data);
      return data;
    },
  });

  const onHandleTracking = () => {
    if (!tracking) {
      if (user?.hasCollection) {
        // this sets off a chain of events caching the collection for comparison
        setTracking(true);
      } else {
        void push(collectionPath);
      }
    } else {
      setTracking(false);
    }
  };

  return (
    <>
      <Line className="my-1" />
      <button
        type="button"
        className={"mr-4 inline-flex items-center text-sm "}
        onClick={onHandleTracking}
      >
        <span
          className={`italic transition-all hover:font-bold ${tracking && "font-bold underline"}`}
        >
          <span>Collection Tracking</span>
        </span>
      </button>

      <Line className="mb-6 mt-1.5" />
    </>
  );
};
